import React from 'react';
import FreedomPanel from '../../Components/SharedComponent/FreedomPanel/FreedomPanel';
import { Grid, useMediaQuery, useTheme } from '@mui/material';
import FreedomVoucherCard from '../../Components/SharedComponent/FreedomVoucherCard/FreedomVoucherCard';
import { PlanVoucherStepWrapper } from '../PlanVoucher1';
import { getStringProduct } from '../../utils/utilityFunctions';

const VoucherFirstStep = ({ voucherArr, ChangeVoucher, selectedVoucher }) => {
  const theme = useTheme()
  const xl4 = useMediaQuery((theme) => theme.breakpoints.up('xl4'))
  const xlll = useMediaQuery((theme) => theme.breakpoints.up('xlll'))
  const xll = useMediaQuery((theme) => theme.breakpoints.up('xll'))
  return (
    // <Grid item xs={12} sm={12} lg={12} marginTop="0px">
      <PlanVoucherStepWrapper>
        <Grid container item spacing={ xl4 ? 2.46*2 : xlll ? 1.66*2 : xll ? 1.25*2 : 2} gap={xl4 ? 6 : 2} display={'flex'} p={xl4 ? 9 : 3}
        sx={{
          gap: 2,
          p: 3,
          [theme.breakpoints.up('xll')]: {
            gap: getStringProduct(1.25, 2),
            p: getStringProduct(1.25, 3)
          },
          [theme.breakpoints.up('xlll')]: {
            gap: getStringProduct(1.66, 2),
            p: getStringProduct(1.66, 3)
          },
          [theme.breakpoints.up('xl4')]: {
            gap: getStringProduct(2.46, 2),
            p: getStringProduct(2.46, 3)
          },
          }}>
          {voucherArr?.map((item, index) => {
            if (item?.id === 11) return;
            return (
              // <Grid key={item?.id} container item >
                <FreedomVoucherCard id={item?.id} ischecked={item?.id == selectedVoucher} title={item?.voucherName} description={item?.description} price={item?.VoucherPrice} expirydate={item?.expiryDate} clickOnCard={() => ChangeVoucher(item)} />
              // </Grid>
            );
          })}
        </Grid>
      </PlanVoucherStepWrapper>
    // </Grid>
  );
};

export default VoucherFirstStep;
